// src/layouts/MobileLayout.js
import React, { createContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer';
import ContentBlockerNotice from '../components/ContentBlockerNotice';
import './MobileLayout.css';

const logoSmall = process.env.REACT_APP_CLIENT_LOGO || '/assets/images/cirenio.svg';

// Contexto para el título de la página
export const PageTitleContext = createContext();

const MobileLayout = () => {
  const [pageTitle, setPageTitle] = useState('');
  const [headerRightContent, setHeaderRightContent] = useState(null);

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle, headerRightContent, setHeaderRightContent }}>
      <div className="layout-horizontal">
        <div className="header-top mobile-layout__header-top">
          <div className="mobile-layout__header-brand">
            <img
              src={logoSmall}
              alt="Logo"
              className="mobile-layout__logo"
            />
            {pageTitle ? <h4 className="mobile-layout__title mb-0">{pageTitle}</h4> : null}
          </div>
          {headerRightContent ? (
            <div className="mobile-layout__header-right">
              {headerRightContent}
            </div>
          ) : null}
        </div>

        <div className="mobile-container">
          <ContentBlockerNotice />
          <Outlet />
        </div>
        <Footer />
      </div>
    </PageTitleContext.Provider>
  );
};

export default MobileLayout; 